import React from 'react'
import { Badge, Nav, Tab } from 'react-bootstrap'
import { CalenderIcon, PillIcon, TraningIcon, WarrentyIcon } from '../../utility/icons/Icons'
import './ownerhome.css'

const AuditSection = () => {
  return (
    <>

                    <div className="common_card h-100">
                        <div className="top border_tittle mb-0 border-0">
                            <div className="top_bar_tittle">
                                <h2>Audit</h2>
                            </div>
                        </div>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="auditall">
                            <div className="flex">
                                <Nav variant="pills" className="common_tab common_tab_sm">
                                    <Nav.Item>
                                        <Nav.Link eventKey="auditall">All</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="auditpersonnel">Personnel</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="auditpolicy">Policy</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="auditoperations">Operations</Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="auditqep">QEP</Nav.Link>
                                    </Nav.Item> */}
                                </Nav>
                            </div>
                            <Tab.Content className="common_content_inner mby_t_16">
                                <Tab.Pane eventKey="auditall">
                                    <div className="auditall_list">
                                        <div className="auditall_card">
                                            <div className="auditall_icon_flx">
                                                <div className="auditall_icon">
                                                    <PillIcon />
                                                    <div className="my_badge">
                                                        <Badge bg="danger">Critical</Badge>
                                                    </div>
                                                </div>
                                                <div className="auditall_card_txt">
                                                    <h3>Critical A.R. 90d <span>- Oldest: 12d</span></h3>
                                                </div>
                                            </div>
                                            <div className="auditall_card_no">
                                                <h3>9</h3>
                                            </div>
                                        </div>
                                        <div className="auditall_card">
                                            <div className="auditall_icon_flx">
                                                <div className="auditall_icon">
                                                    <CalenderIcon />
                                                    <div className="my_badge">
                                                        <Badge bg="warning">High</Badge>
                                                    </div>
                                                </div>
                                                <div className="auditall_card_txt">
                                                    <h3>Monthlies not submitted <span>- Oldest: 6d</span></h3>
                                                </div>
                                            </div>
                                            <div className="auditall_card_no">
                                                <h3>8</h3>
                                            </div>
                                        </div>
                                        <div className="auditall_card">
                                            <div className="auditall_icon_flx">
                                                <div className="auditall_icon">
                                                    <WarrentyIcon />
                                                    <div className="my_badge">
                                                        <Badge bg="warning">High</Badge>
                                                    </div>
                                                </div>
                                                <div className="auditall_card_txt">
                                                    <h3>Policy acknowledgments missing</h3>
                                                </div>
                                            </div>
                                            <div className="auditall_card_no">
                                                <h3>5</h3>
                                            </div>
                                        </div>
                                        <div className="auditall_card">
                                            <div className="auditall_icon_flx">
                                                <div className="auditall_icon">
                                                    <TraningIcon />
                                                    <div className="my_badge">
                                                        <Badge bg="warning">High</Badge>
                                                    </div>
                                                </div>
                                                <div className="auditall_card_txt">
                                                    <h3>Training expired <span>- Oldest: 5d</span></h3>
                                                </div>
                                            </div>
                                            <div className="auditall_card_no">
                                                <h3>3</h3>
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="auditpersonnel">

                                </Tab.Pane>
                                <Tab.Pane eventKey="auditpolicy">auditpolicy tab content</Tab.Pane>
                                <Tab.Pane eventKey="auditoperations">auditoperations tab content</Tab.Pane>
                                <Tab.Pane eventKey="auditqep">auditqep tab content</Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
    </>
  )
}

export default AuditSection